import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { getLessonMeta } from '@/constants/learnCurriculum';
import { Kicker, useLanding } from '@/components/Landing/LandingKit';

export default function LearnHeader({ slug, title, description, badge, difficulty, readMinutes }) {
  const { c, isXS } = useLanding();
  const meta = getLessonMeta(slug);
  const workshop = ['agentic', 'projects'].includes(meta?.module?.id);
  const minutes = readMinutes || meta?.lesson?.minutes;
  return (
    <View style={{ marginBottom: workshop ? 24 : 32 }}>
      <Kicker>{meta ? `${meta.module.title} / ${String(meta.index).padStart(2, '0')}` : badge || 'Learn Gab AI'}</Kicker>
      <Text tag="h1" weight="semibold" style={{ color: c.ink, fontSize: isXS ? 34 : workshop ? 44 : 48, lineHeight: isXS ? 39 : workshop ? 49 : 53, letterSpacing: -1.6, marginTop: 20 }}>{title}</Text>
      {description && <Text tag="p" style={{ color: c.inkSoft, fontSize: workshop ? 16 : 18, lineHeight: workshop ? 26 : 29, marginTop: workshop ? 12 : 18 }}>{description}</Text>}
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 16, marginTop: workshop ? 12 : 24 }}>
        <Text style={{ color: c.muted, fontSize: 13 }}>{difficulty || 'Self-paced'}</Text>
        {minutes ? <Text style={{ color: c.muted, fontSize: 13 }}>{minutes} min read · allow time to create</Text> : null}
      </View>
    </View>
  );
}
